import Swal from 'sweetalert2'
import ImageWarning from '../images/warning2.svg'
import ImageWomen from '../images/Women-stand.png'
import ImagSuccess from '../images/img-success.png'

export default function SwalCustom({
  icon,
  imageWarning = false,
  preConfirm,
  text = '',
  title = '',
  confirmButtonColor = '#32BE38',
  showConfirmButton = true,
  showCancelButton = false,
  confirmButtonText = 'Close',
  cancelButtonText = 'Cancel',
  timer,
  cancelButtonColor,
  inputAttributes,
  input,
  imageSize = 130,
  showLoaderOnConfirm
}) {
  const fnCheckImage = () => {
    if (icon === 'success') {
      return {
        image: ImagSuccess
      }
    } else if (icon === 'error') {
      return {
        image: ImageWarning
      }
    } else {
      return {
        image: ImageWomen
      }
    }
  }

  return Swal.fire({
    html: ` <div class=" container-fluid">
              <div class="row mt-3">
                <div class="col-12 d-flex justify-content-center">
                   <div style="width: 120px; height: 120px; border-radius: 50%; background-color:#eef4ff;"
                      class="d-flex align-items-center justify-content-center">
                    <img src="${imageWarning ? ImageWarning : fnCheckImage().image}" style="height:80px; "  class="img-fluid" />
                  </div>
                </div>
                <div class="col-12 text-start d-block align-self-center" style="margin-top:26px; margin-bottom: 26px;">
                  <h3 class="text-center" style="color:#263146;font-size: 20px; font-weight: 700;">${title}</h3>
                ${text && `<p class="mb-0 small text-center">${text ?? ''}</p>`}  
                </div>
              </div>
            </div>`,
    showCancelButton,
    showConfirmButton,
    confirmButtonColor,
    confirmButtonText,
    cancelButtonText,
    timer,
    cancelButtonColor,
    preConfirm,
    inputAttributes,
    input,
    showLoaderOnConfirm
  })
}
